module.exports = __webpack_public_path__ + "static/dl2-stay-human_full-7e2a3c68190c59a0f5b0bb7d4a108e67.jpg";